import LazyRouter from "@/components/LazyRouter";
import { Navigate, RouteObject } from "react-router";

/**客服路由 */
const service_routers: RouteObject[] = [
    {
        element: <LazyRouter load={() => import("@/pages/layout")} />,
        children: [
            {
                path: "dashboard",
                element: <LazyRouter load={() => import("@/pages/dashboard")} />,
            },
        ]
    },
    { path: "video", element: <LazyRouter load={() => import("@/pages/video")} /> },
    { path: "login", element: <LazyRouter load={() => import("@/pages/login")} /> },
    { path: "*", element: <Navigate to={"/dashboard"} /> },
];

export default service_routers;